import styled, { css } from 'styled-components';

export const InputContainer = styled.div`
  justify-content: center;
  align-items: center;
  position: ${({ theme }) => theme.positions.relative};
  width: 100%;

  & .myaudit-filter-date-picker {
      height: ${({ theme }) => theme.height.h6};
      width: 100%;
      border: ${({ theme }) => `1px solid ${theme.colors.platinumDark}`};
      border-radius: ${({ theme }) => theme.spacing.s};
      padding: 0 11px; // added this temporarily when doing a myLqa revamp this will be removed
  }
`;

export const MyAuditDatePickerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const CalendarIconContainer = styled.div`
  position: ${({ theme }) => theme.positions.absolute};
  top: 14px;
  right: ${({ theme }) => theme.spacing.m};
`;

export const DatePickerWrapper = styled.div(
  ({ theme }) => css`
    & .react-datepicker-popper {
      z-index: 99;
    }
    & .react-datepicker {
      border: 1px solid ${theme.colors.platinumDark};
      box-shadow: ${theme.spacing.none}
        ${theme.spacing.sm} ${theme.spacing.sm}
        ${theme.spacing.none} #00000017;
      //this is to update the month desgin on the datePicker
      & .react-datepicker__current-month {
        font-family: ${theme.font.default};
        font-weight: ${theme.fontWeight.semiBold};
        font-size: ${theme.fontSize.m};
        color: ${theme.colors.eerieBlack};
        letter-spacing: ${theme.spacing.none};
        line-height: ${theme.lineHeight.lh4};
      }
      & .react-datepicker__day-names {
        margin-bottom: ${theme.spacing.none};
      }
      //this is to update the days on the datePicker
      & .react-datepicker__day-name,
      .react-datepicker__day,
      .react-datepicker__time-name {
        font-family: ${theme.font.default};
        font-weight: ${theme.fontWeight.medium};
        font-size: ${theme.fontSize.m};
        color: ${theme.colors.eerieBlack};
        width: 30px;
        height: 30px;
        padding: ${theme.spacing.xs}
          ${theme.spacing.xxs};
      }
      //this is to update the selected date
      & .react-datepicker__day--keyboard-selected,
      .react-datepicker__month-text--keyboard-selected,
      .react-datepicker__quarter-text--keyboard-selected,
      .react-datepicker__year-text--keyboard-selected,
      .react-datepicker__day--selected,
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--selected,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--selected,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--selected,
      .react-datepicker__year-text--in-selecting-range,
      .react-datepicker__year-text--in-range {
        background-color: ${theme.colors.seasalt};
        font-family: ${theme.font.default};
        font-weight: ${theme.fontWeight.semiBold};
        font-size: ${theme.fontSize.m};
        color: ${theme.colors.eerieBlack};
      }
      & .react-datepicker__day--disabled,
      .react-datepicker__month-text--disabled,
      .react-datepicker__quarter-text--disabled,
      .react-datepicker__year-text--disabled {
        color: ${theme.colors.platinumDark};
      }
      & .react-datepicker__day-names .react-datepicker__day-name {
        font-family: ${theme.font.default};
        font-weight: ${theme.fontWeight.semiBold};
        font-size: ${theme.fontSize.m};
        color: ${theme.colors.dimGray};
      }
      & .react-datepicker__header {
        border-bottom: 1px solid ${theme.colors.platinumDark};
        padding-top: ${theme.spacing.m};
      }
      & .react-datepicker__navigation {
        top: ${theme.spacing.s};
      }
      & .react-datepicker__navigation-icon::before {
        border-width: 1px 1px ${theme.spacing.none}
          ${theme.spacing.none};
        border-color: ${theme.colors.dimGray};
      }
    }
  `
);
